<template>
    <div class="container d-flex flex-column justify-content-center align-items-center py-5">
      <h1 class="mb-3">{{ $t('contact.title') }}</h1>

      <!-- 成功提示 -->
      <div v-if="ui.success" class="alert alert-success" role="alert">
        {{ $t('contact.alert_success') }}
      </div>

      <!-- 失敗提示 -->
      <div v-if="ui.error" class="alert alert-danger" role="alert">
        {{ $t('contact.alert_failure') }}
      </div>

      <form @submit.prevent="submitForm" class="col-12 col-md-8 col-lg-6" novalidate>
        <div class="mb-3">
          <label for="name" class="form-label">{{ $t('contact.name') }}</label>
          <input
            v-model.trim="form.name"
            type="text"
            id="name"
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            @input="clearError('name')"
          />
          <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
        </div>

        <div class="mb-3">
          <label for="email" class="form-label">{{ $t('contact.email') }}</label>
          <input
            v-model.trim="form.email"
            type="email"
            id="email"
            class="form-control"
            :class="{ 'is-invalid': errors.email }"
            @input="clearError('email')"
          />
          <div class="invalid-feedback" v-if="errors.email">{{ errors.email }}</div>
        </div>

        <div class="mb-3">
          <label for="message" class="form-label">{{ $t('contact.content') }}</label>
          <textarea
            v-model.trim="form.message"
            id="message"
            rows="4"
            class="form-control"
            :class="{ 'is-invalid': errors.message }"
            @input="clearError('message')"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.message">{{ errors.message }}</div>
        </div>

        <button class="btn btn-primary" :disabled="ui.loading">
          <span v-if="ui.loading" class="spinner-border spinner-border-sm me-2"></span>
          {{ $t('contact.submit') }}
        </button>
      </form>
    </div>
</template>

<script setup>
import { reactive } from 'vue'
import api from '@/utils/api'  // 直接引入封裝的 axios
// import { computed } from 'vue'
// import { useI18n } from 'vue-i18n'
// import { setLocale } from '@/i18n'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const form = reactive({
  name: '',
  email: '',
  message: ''
})

const ui = reactive({ loading: false })

const errors = reactive({
  name: '',
  email: '',
  message: ''
})

function validate() {
  // 清空
  errors.name = ''
  errors.email = ''
  errors.message = ''

  // 必填
  if (!form.name) errors.name = t('validation.required')
  if (!form.email) errors.email = t('validation.required')
  if (!form.message) errors.message = t('validation.required')

  // email 格式（只在非空時檢查）
  if (!errors.email && form.email) {
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)
    if (!ok) errors.email = t('validation.email')
  }

  // 範例：訊息至少 5 個字
  if (!errors.message && form.message && form.message.length < 5) {
    errors.message = t('validation.minLen', { n: 5 })
  }

  // 回傳是否通過
  return !errors.name && !errors.email && !errors.message
}

function clearError(field) {
  errors[field] = ''
}

async function submitForm() {
  ui.loading = true
  ui.success = false
  ui.error = false

  try {
    if (!validate()) return

    ui.loading = true

    const res = await api.post('/api/Email/send', {
      name: form.name,
      email: form.email,
      message: form.message
    })

    if (!res.data || res.data.ok === false) {
      throw new Error(res.data?.error || 'MAIL_SEND_FAILED')
    }

    ui.success = true
    form.name = ''
    form.email = ''
    form.message = ''
  } catch (err) {
    console.error(err)
    ui.error = true
  } finally {
    ui.loading = false
  }
}
</script>